import { useState } from "react";
import { Button } from "./ui/button";
import { UserPlus, UserMinus, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useTranslation } from "../i18n";

const API = '/api';

export function FollowButton({ username, userId, isFollowing: initialFollowing, isSelf, size = "default", onToggle }) {
  const { t } = useTranslation();
  const [following, setFollowing] = useState(initialFollowing);
  const [loading, setLoading] = useState(false);

  // Resolve identifier: prefer username, fall back to userId
  const identifier = username || userId;

  if (isSelf || !identifier) return null;

  const handleToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    try {
      if (following) {
        await axios.delete(`${API}/profile/${identifier}/follow`);
        setFollowing(false);
        onToggle?.(false);
      } else {
        await axios.post(`${API}/profile/${identifier}/follow`, {});
        setFollowing(true);
        onToggle?.(true);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={following ? "outline" : "default"}
      size={size}
      onClick={handleToggle}
      disabled={loading}
      className={`min-h-[36px] ${following ? "hover:text-destructive hover:border-destructive" : "btn-scale"}`}
      data-testid={`follow-btn-${identifier}`}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : following ? (
        <><UserMinus className="w-4 h-4 mr-1.5" />{t.social.unfollow}</>
      ) : (
        <><UserPlus className="w-4 h-4 mr-1.5" />{t.social.follow}</>
      )}
    </Button>
  );
}
